"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTUID = createTUID;
exports.splitMultipartUID = splitMultipartUID;
const constants_1 = require("./document/constants");
const constants_2 = require("./part/constants");
function createTUID(terminalData) {
    let terminalUid, elementUid;
    if (Array.isArray(terminalData)) {
        [elementUid, terminalUid] = terminalData;
    }
    else if ("terminalUid" in terminalData) {
        ({ elementUid, terminalUid } = terminalData);
    }
    else {
        ({ element_uid: elementUid, terminal_uid: terminalUid } = terminalData);
    }
    if (terminalUid === constants_2.GENESIS_TERMINAL_TERMINAL_UID) {
        // If the part itself is a terminal, then the terminalId adds no information.
        // When PCB terminal nodes are created to match genesis terminal elements, they
        // also use this scheme for their uid, so it's important to ensure it matches
        // the uid used by netmap creation.
        // Note: this is also highly important for how outer (host) nets are connected
        // to submodule nets. See comment about this in netMapping.ts
        return elementUid;
    }
    else {
        return `${elementUid}${constants_1.nestedNodeDelimiter}${terminalUid}`;
    }
}
function splitMultipartUID(uid) {
    const parts = uid.split(constants_1.nestedNodeDelimiter);
    const parentUid = parts.slice(0, -1).join(constants_1.nestedNodeDelimiter);
    const leafUid = parts.at(-1);
    return [parentUid, leafUid];
}
//# sourceMappingURL=uid.js.map